import React from 'react';
import ModuleRoute from 'holocron-module-route';

import ErrorLayout from './components/ErrorLayout';
import ErrorPage from './components/ErrorPage';

const childRoutes = () => [
  <ModuleRoute key="/" path=":locale">
    <ModuleRoute path="wallet/:product" moduleName="axp-digital-credentials-holder" />
    <ModuleRoute path="verifier/:product" moduleName="axp-digital-credentials-verifier" />
  </ModuleRoute>,
  <ModuleRoute key="error" component={ErrorLayout}>
    <ModuleRoute
      code="500"
      component={ErrorPage}
      path="*/error"
      status={500}
    />
    <ModuleRoute
      code="404"
      component={ErrorPage}
      path="*"
      status={404}
    />
  </ModuleRoute>,
];

export default childRoutes;
